// @flow

import help from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Help';
import radio from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Radio';
import { createDefaultContact } from 'app/developer-v3/components/PartnerSupportForm/content/nodes/common/defaultContact';

export const createIssueOrBugs = () => ({
  value: 'issuesOrBugs',
  label: 'Experiencing Issues or Bugs with my app',
  zendeskCustomFieldValue: 'pcf-existing-bug',
  child: radio({
    id: 'isuessorbug',
    label: 'What kind of issue or bug can we help you with?',
    zendeskCustomFieldId: 360044626551,
    items: [
      {
        value: 'bug-affecting-users',
        label: 'Bug/unexpected behavior affecting our users',
        zendeskCustomFieldValue: 'pcf-existing-bugs-affecting-users',
        child: help({
          contact: createDefaultContact({
            media: {
              label: `Please upoad a screenshot of the bug or issue you're having.`,
            },
          }),
        }),
      },
      {
        value: 'bug-affecting-dev',
        label: 'Bug/unexpected behavior affecting app development',
        zendeskCustomFieldValue: 'pcf-existing-bugs-affecting-development',
        child: help({
          contact: createDefaultContact({
            media: {
              label: `Please upoad a screenshot of the bug or issue you're having.`,
            },
          }),
        }),
      },
    ],
  }),
});
